export class ImgproxyService {
    constructor(host, config) {
        this.host = host;
        this.config = config;
    }
    generateUrl(imageConfig) {
        // Debug point: Start URL generation
        const processingOptions = this.buildProcessingOptions(imageConfig);
        if (processingOptions)
            return `${this.host}/insecure/${processingOptions}/plain/${imageConfig.src}`;
        // Debug point: URL generated
        return `${this.host}/insecure/plain/${imageConfig.src}`;
    }
    buildProcessingOptions(config) {
        const options = [];
        if (config.width || config.height) {
            // Apply retina sizing (double dimensions) if retina option is enabled
            const multiplier = this.config?.retina ? 2 : 1;
            const width = config.width ? config.width * multiplier : 0;
            const height = config.height ? config.height * multiplier : 0;
            options.push(`rs:${config.resizingType || 'auto'}:${width}:${height}`);
        }
        if (config.gravity) {
            options.push(`g:${config.gravity}`);
        }
        if (config.enlarge) {
            options.push('el:1');
        }
        if (config.extend) {
            options.push('ex:1');
        }
        if (config.format) {
            options.push(`f:${config.format}`);
        }
        if (config.quality) {
            options.push(`q:${config.quality}`);
        }
        return options.join('/');
    }
    isSameUrl(element, newConfig) {
        const currentUrl = element.nodeName === 'IMG'
            ? element.src
            : element.style.backgroundImage?.replace(/^url\(['"](.+)['"]\)$/, '$1');
        const newUrl = this.generateUrl(newConfig);
        return currentUrl === newUrl;
    }
}
//# sourceMappingURL=imgproxy.service.js.map